module.exports = __webpack_public_path__ + "static/media/features.9dbf15cf.png";